import React, { useState, useEffect, useContext } from "react";
import VylabsIcon from "../../Assets/Images/VybogTAL-Logo.svg";
import vybogTALDarkLogo from "../../Assets/Images/VybogTAL-Logo-Dark.svg";
import vybogtalLogoImg from "../../Assets/Images/vybogtal-logo-img.png"
import BorderLinearProgressBar from "../../Common/Border-linear-process/BorderLinearProgress";
import { useNavigate } from "react-router-dom";
import "./Signup.css";
import { DynamicContext } from "../../Context/DynamicContext";
import {
  VYLABS_BASE_URL,
  LOGIN_URL,
  VYLABS_USER_DASHBOARD_URL,
} from "../../helper/url_helper";
import { post } from "../../helper/Api_helper";
import { Toast } from "../../Common/Toast-Snackbar/ToastSnackbar";
import { TENANT_OTP_API_KEY } from "../../Tenant-Config/TenantConfig";

function SignupCompletion() {
  const { signupEmail, signupPassword, setUserDetails, isDarkMode } =
    useContext(DynamicContext);
  const [progress, setProgress] = useState(0);
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      localStorage.removeItem("sessionExpired");
      const response = await post(VYLABS_BASE_URL, LOGIN_URL, {
        email: signupEmail,
        password: signupPassword,
      },
      {
        _skipAuth: true, 
        headers: {
          "X-API-Key": TENANT_OTP_API_KEY,
        },
      },
    );
      const { access_token, user } = response || {};
      localStorage.setItem("token", access_token);
      localStorage.setItem("user", JSON.stringify(user));

      setUserDetails(user);
      Toast("success", "Login Successfully");
      navigate("/dashboard", { state: { userData: user } });
    } catch (error) {
      console.error("Login error:", error);
      let errorMessage = "An error occurred during login. Please try again.";
      if (error.response?.data) {
        errorMessage = error.response.data;
      }
      Toast("error", errorMessage);
      navigate("/");
    }
  };

  useEffect(() => {
    if (signupEmail && signupPassword) {
      handleLogin();
    } else {
      console.error("Missing email or password. Please try again.");
      navigate("/");
    }
  }, [signupEmail, signupPassword]);

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((oldProgress) => {
        if (oldProgress >= 100) {
          clearInterval(timer);
          return 100;
        }
        const diff = Math.random() * 10;
        return Math.min(oldProgress + diff, 100);
      });
    }, 800);
    return () => clearInterval(timer);
  }, []);

  return (
    <div
      className={`signup-outer-container ${isDarkMode ? "no-bg-image" : ""}`}
    >
      <div className="signup-icon-text">
        <img
          alt="VylabsIcon"
          src={isDarkMode ? vybogTALDarkLogo : VylabsIcon}
          className="vy-labs-logo"
          style={{ width: "15%" }}
        />
      </div>
      <div className="signup-completion-outer-container">
        <img
          src={vybogtalLogoImg}
          alt="vybogtalLogoImg"
          style={{ width: "200px", zIndex: "44" }}
          className="completion-alone-main-image"
        />       
        <div className="signup-completion-text-container">
          <h1 style={{ color: "#544DCD" }} className="signup-main-header">
            Welcome to VybogTAL
          </h1>
          <span className="signup-side-text">
            Your smarter way to manage candidates and jobs begins here.
          </span>
        </div>
        <div className="signup-progress-bar-container">
          <h3 style={{ color: "#544DCD" }}>
            Powering up your VybogTAL dashboard...
          </h3>
          <BorderLinearProgressBar
            value={progress}
            sx={{ width: "100%", height: "8px" }}
            progressColor="#544DCD"
          />
        </div>
      </div>
    </div>
  );
}

export default SignupCompletion;
